module.exports = __webpack_public_path__ + "img/cause3Orange.8686dda5.png";